export const eventCategories = [
  { label: "Shop & Dine", value: "Shop & Dine" },
  { label: "Interactivity", value: "Interactivity" },
  { label: "Wellness", value: "Wellness" },
  { label: "Community", value: "Community" },
];

export const directoryCategories = [
  { label: "Fine Dining", value: "Fine Dining" },
  { label: "Casual Dining", value: "Casual Dining" },
  { label: "Cafes and Coffee Shops", value: "Cafes and Coffee Shops" },
  { label: "Entertainment", value: "Entertainment" },
  { label: "Shopping", value: "Shopping" },
  { label: "Health and Wellness", value: "Health and Wellness" },
  { label: "Services", value: "Services" }
];
